import { useTranslation } from '@/i18n';
import { IconAi, TextLink } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import styles from './AiSuggestSummaryBanner.module.scss';

const cx = classnames.bind(styles);

export type ReferencedReportLinkProps = {
  /** Reference report number with prefix (e.g. `AP1190`). */
  number: string;
  /** Detail path of the referenced report; when present the number is a link. */
  detailPath?: string;
};

const InnerReferencedReportLink: FC<ReferencedReportLinkProps> = ({
  number,
  detailPath,
}) => {
  const { t } = useTranslation();

  return (
    <div className={cx('reference')}>
      <span className={cx('reference-label')}>
        <IconAi size={18} />
        <span className={cx('reference-title')}>
          {t('referenced_application_title')}
        </span>
      </span>
      {detailPath ? (
        <TextLink href={detailPath} target='_blank'>
          <span className={cx('reference-link')}>{number}</span>
        </TextLink>
      ) : (
        <span className={cx('reference-number')}>{number}</span>
      )}
    </div>
  );
};

InnerReferencedReportLink.displayName = 'InnerReferencedReportLink';

export const ReferencedReportLink: FC<ReferencedReportLinkProps> = memo(
  InnerReferencedReportLink
);
ReferencedReportLink.displayName = 'ReferencedReportLink';
